(() => {
  if (window.lrGatewayLoaded) return;
  window.lrGatewayLoaded = true;
  const instances = new Map();
  function mount(root) {
    if (instances.has(root)) return;
    const abort = new AbortController();
    const listen = (el, event, fn) => el.addEventListener(event, fn, {signal: abort.signal});
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    const hover = matchMedia('(hover: hover) and (pointer: fine)');
    const players = [];
    root.querySelectorAll('.lr-department').forEach(panel => {
      const video = panel.querySelector('video');
      const button = panel.querySelector('[data-lr-video-toggle]');
      if (!video || !button) return;
      let suppressed = false;
      let revision = 0;
      video.controls = false;
      video.muted = true;
      button.hidden = false;
      const update = () => {
        const playing = !video.paused;
        const label = playing ? root.dataset.pauseLabel : root.dataset.playLabel;
        button.setAttribute('aria-label', `${label} — ${button.dataset.title}`);
        button.querySelector('[data-lr-video-label]').textContent = label;
        button.querySelector('[data-lr-video-icon]').textContent = playing ? 'Ⅱ' : '▶';
        panel.classList.toggle('is-playing', playing);
      };
      const pause = () => { revision++; video.pause(); update(); };
      const play = async () => {
        const request = ++revision;
        players.forEach(player => { if (player.video !== video) player.pause(); });
        try { await video.play(); if (request !== revision) video.pause(); } catch (_) { /* Poster and manual control remain available. */ }
        update();
      };
      players.push({video, pause});
      listen(video, 'play', update);
      listen(video, 'pause', update);
      listen(panel, 'pointerenter', () => { if (hover.matches && !reduced.matches && !suppressed) play(); });
      listen(panel, 'pointerleave', () => { suppressed = false; pause(); });
      listen(panel, 'focusin', event => { if (event.target.closest('a') && !reduced.matches && !suppressed) play(); });
      listen(panel, 'focusout', event => { if (!panel.contains(event.relatedTarget)) { suppressed = false; pause(); } });
      listen(button, 'click', () => { if (video.paused) { suppressed = false; play(); } else { suppressed = true; pause(); } });
      update();
    });
    const stop = () => players.forEach(player => player.pause());
    listen(document, 'visibilitychange', () => { if (document.hidden) stop(); });
    listen(reduced, 'change', () => { if (reduced.matches) stop(); });
    const observer = new IntersectionObserver(entries => { if (!entries[0].isIntersecting) stop(); });
    observer.observe(root);
    instances.set(root, () => { stop(); abort.abort(); observer.disconnect(); });
  }
  const init = scope => scope.querySelectorAll('[data-lr-gateway]').forEach(mount);
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    for (const [root, cleanup] of instances) if (event.target.contains(root)) { cleanup(); instances.delete(root); }
  });
})();
